/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getCardContainerStyles } from '../styles';

/**
 * Card container with styles that can renders custom title, custom content and custom footer.
 * @constructor
 *
 * @param {object} props - All props
 * @param {node} props.title - Custom title
 * @param {node} props.content - Custom content
 * @param {node} [props.footer=null] - Custom footer
 * @param {node} [props.className=null] - Custom class name
 * @param {node} [props.headerClassName=null] - Custom header class name
 * @param {node} [props.titleClassName=null] - Custom title class name
 * @param {node} [props.bodyClassName=null] - Custom body class name
 * @param {node} [props.contentClassName=null] - Custom content class name
 * @param {node} [props.footerClassName=null] - Custom footer class name
 */
export const CardContainer = ({
  title,
  content,
  footer,
  className,
  headerClassName,
  titleClassName,
  bodyClassName,
  contentClassName,
  footerClassName,
}) => {
  const classes = useDefaultStyles(getCardContainerStyles);

  return (
    <div className={classNames('card-container', classes.container, className)}>
      <div className={classNames('card-container-header', classes.header, headerClassName)}>
        <div className={classNames('card-container-title', classes.title, titleClassName)}>
          {title}
        </div>
      </div>
      <div className={classNames('card-container-body', classes.body, bodyClassName)}>
        <div className={classNames('card-container-content', contentClassName)}>
          {content}
        </div>
        { footer && (
          <div className={classNames('card-container-footer', classes.footer, footerClassName)}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

CardContainer.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
};

CardContainer.defaultProps = {
  footer: null,
  className: null,
  headerClassName: null,
  titleClassName: null,
  bodyClassName: null,
  contentClassName: null,
  footerClassName: null,
};
